 (function(angular){
	'use strict';
	
	angular
		.module('redemptionRequestModule')
		.controller('RedemptionRequestFormController', [
			'$filter',
			'globalConfig',
			'INVESTMENT_ENTITY_ID',
			'mixpanelFactory',
			'$timeout',
			'urlFactory',
			RedemptionRequestFormControllerFunction
		]);
	
	function RedemptionRequestFormControllerFunction(
		$filter,
		globalConfig,
		INVESTMENT_ENTITY_ID,
		mixpanelFactory,
		$timeout,
		urlFactory
	){
		var request = this;
		var debounce;

		request.updateTables = function(inputToTouch) {
			if(debounce){
				$timeout.cancel(debounce);
			}

			if(inputToTouch){
				request.requestForm[inputToTouch].$setTouched();
			}

			var formattedRequest = request.formatRequest();

			if(formattedRequest.requests.length === 0) {
				delete request.tableData;
				request.requestForm.$setValidity('reitsSelected', false);
			} else {
				request.requestForm.$setValidity('reitsSelected', true);
				request.loadingTables = true;
				debounce = $timeout(function() {
					urlFactory.postPromise('/reits/redemptions/request/discounts-table.json', formattedRequest).then(function(response){
						request.loadingTables = false;
						request.tableData = Object.keys(response.data).length ? response.data : undefined;
					});
				}, 300);
			}
		};

		request.toggleFractional = function() {
			request.reits.forEach(function(reit){ delete reit.sharesRequested; });
			delete request.tableData;
			request.requestForm.$setValidity('reitsSelected', false);
			request.fractional = !request.fractional;
		};

		request.submitRedemption = function() {
			var urlPrefix = '/' + request.type + '/redemptions/request';

			urlFactory.postPromise(urlPrefix + '/submit', request.formatRequest())
				.then(function(){
					urlFactory.redirect(urlPrefix + '/survey');
				})
				.catch(function(error){
					request.formSubmitted = false;
					urlFactory.handleFailedRequest(error);
				});
		};

		request.formatRequest = function(){
			var requestedReits = $filter('filter')(request.reits, function(reit){ return angular.isDefined(reit.sharesRequested) && reit.sharesRequested > 0;}, true);

			return {
				'requests': requestedReits,
				'reitRedemptionType': request.type === 'ipo' ? 'QUARTERLY' : 'MONTHLY',
				'investmentEntityId': INVESTMENT_ENTITY_ID
			};
		};

		function setMaximumState(){
			request.reitOverMaximum = request.reits.some(function(reit){
				return reit.sharesOutstanding > reit.maxRedeemableShares;
			});
			request.fractional = request.reitOverMaximum;
		}

		function setFullRedemptionAlerts(){
			var alertList = [];

			if(request.hasCurrentInvestmentGoal){
				alertList.push('delete your current investment goal');
			}

			if(request.isAutoInvestor){
				alertList.push('disable auto-invest');
			}

			if(request.isReInvestor){
				alertList.push('disable dividend reinvestment');
			}

			if(alertList.length === 0) {
				request.fullRedemptionAlertMsg = undefined;
			} else if(alertList.length === 1) {
				request.fullRedemptionAlertMsg = alertList[0];
			} else {
				var last = alertList.pop();
				request.fullRedemptionAlertMsg = alertList.join(', ') + ' and ' + last;
			}
		}
		
		request.$onInit = function() {
			angular.extend(request, globalConfig);
			request.isIpoRedemptionRequest = urlFactory.urlContains('/ipo');
			request.type = request.isIpoRedemptionRequest ? 'ipo' : 'reits';
			request.fractional = false;
			request.loadingTables = false;
			setFullRedemptionAlerts();

			urlFactory.getPromise('/' + request.type + '/redemptions/request/get-reits-available.json')
				.then(function(response){
					request.loaded = true;
					request.reits = response.data.length ? response.data : undefined;
					if(request.reits){
						setMaximumState();
						mixpanelFactory.track('Redemption Request Form Page Viewed');
					} else{
						mixpanel.track("Redemption Request Form Viewed With No Available Redemptions");
					}
					
					$timeout(function(){
						request.requestForm.$setValidity('reitsSelected', false);
					}, 100);
				})
				.catch(function(error){
					urlFactory.handleFailedRequest(error);
				});
		};
	}
})(window.angular);